import { createElementBlock as o, openBlock as e, createElementVNode as l } from "vue";
import r from "./index289.js";
const a = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(c, t, p, m, f, i) {
  return e(), o("svg", n, t[0] || (t[0] = [
    l("path", {
      fill: "currentColor",
      d: "m8.688 7.926-5.78.722-.106.02a.75.75 0 0 0-.338 1.248l4.111 4.206-1.132 5.733-.013.1a.75.75 0 0 0 1.07.722l5.5-2.612 5.5 2.612.092.038a.75.75 0 0 0 .965-.86l-1.133-5.733 4.112-4.206.07-.08a.75.75 0 0 0-.513-1.188l-5.782-.722-2.64-5.262a.75.75 0 0 0-1.341 0L8.688 7.926ZM12 4.672l2.15 4.285.055.092c.12.173.31.29.523.316l4.677.584-3.33 3.407-.067.08a.75.75 0 0 0-.132.59l.92 4.657-4.474-2.125-.104-.04a.75.75 0 0 0-.54.04l-4.475 2.125.92-4.658.014-.104a.75.75 0 0 0-.213-.565l-3.33-3.407 4.678-.584a.75.75 0 0 0 .577-.408L12 4.672Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ r(a, [["render", s]]);
export {
  u as default
};
